import { z } from 'zod/v4';
export var EndReasonCategory;
(function (EndReasonCategory) {
    EndReasonCategory["Success"] = "SUCCESS";
    EndReasonCategory["Unresolved"] = "UNRESOLVED";
    EndReasonCategory["NotPossible"] = "NOT_POSSIBLE";
    EndReasonCategory["Error"] = "ERROR";
})(EndReasonCategory || (EndReasonCategory = {}));
export const CreateEndReasonSchema = z.object({
    handle: z.string().optional(),
    label: z.string(),
    category: z.enum(EndReasonCategory),
});
export const UpdateEndReasonSchema = z.object({
    handle: z.string().optional(),
    label: z.string().optional(),
    category: z.enum(EndReasonCategory).optional(),
});
//# sourceMappingURL=index.js.map